import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { Fragment } from "react";
import { Link, LinkProps } from "react-router-dom";
import tw from "twin.macro";

interface BreadcrumbProps {
  items: Pick<LinkProps, "children" | "to">[];
}

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  if (items.length === 0) {
    return null;
  }
  return (
    <Fragment>
      {items.length > 1 && (
        <nav tw="sm:hidden" aria-label="Back">
          <Link
            // use the before last item for the "Back" button
            to={items[items.length - 2].to}
            tw="flex items-center text-sm font-medium text-gray-600 hover:text-gray-800"
          >
            <ChevronLeftIcon
              tw="-ml-1 mr-1 h-5 w-5 shrink-0 text-gray-500"
              aria-hidden="true"
            />
            Retour
          </Link>
        </nav>
      )}
      <nav tw="hidden sm:flex" aria-label="Breadcrumb">
        <ol role="list" tw="flex items-center space-x-4">
          {items.map((item, index) => (
            <li key={JSON.stringify(item)}>
              <div tw="flex items-center">
                {index > 0 && (
                  <ChevronRightIcon
                    tw="h-5 w-5 shrink-0 text-gray-500"
                    aria-hidden="true"
                  />
                )}
                <Link
                  to={item.to}
                  css={[
                    tw`text-sm font-medium text-gray-600 hover:text-gray-800`,
                    index > 0 && tw`ml-4`,
                  ]}
                >
                  {item.children}
                </Link>
              </div>
            </li>
          ))}
        </ol>
      </nav>
    </Fragment>
  );
};

export default Breadcrumb;
